export default function CTAIndex() {
  return (
    <section className="py-12 sm:py-16 md:py-24 bg-primary text-white">
      <div className="container px-4 sm:px-6">
        <div className="text-center max-w-4xl mx-auto">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-display font-semibold mb-4 sm:mb-6 md:mb-8 tracking-tight px-2">
            Ready to share your creator profile?
          </h2>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl mb-6 sm:mb-8 md:mb-10 opacity-90 font-dm-sans font-normal leading-relaxed px-4">
            Build a brand-ready profile you can send to any brand in seconds.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center px-4">
            <a href="/signup" className="w-full sm:w-auto border-2 border-white text-white px-8 sm:px-12 py-4 sm:py-5 rounded-xl sm:rounded-2xl text-base sm:text-lg font-semibold hover:bg-white hover:text-primary transition-all duration-200 font-dm-sans min-h-[48px] flex items-center justify-center">
              Create your profile
            </a>
            <a href="/login" className="w-full sm:w-auto text-white px-8 sm:px-12 py-4 sm:py-5 rounded-xl sm:rounded-2xl text-base sm:text-lg font-semibold hover:bg-white/10 transition-all duration-200 font-dm-sans min-h-[48px] flex items-center justify-center">
              Log In
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
